/* Publish by EComposer at 2026-10-02 08:13:47*/
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-am4rnkwbol5"]=  window.__ectimmers["ecom-am4rnkwbol5"] || {};
if(!this.$el)return;const t=this.$el,e=t.querySelector(".ecom-text_view-more-btn"),i=t.querySelector(".ecom-text_view-less-btn"),o=t.querySelector(".text-content.ecom-html");!o||(e&&e.addEventListener("click",()=>{o.classList.remove("ecom-text--is-mark"),o.style.maxHeight="",e.style.display="none",i.style.display=""}),i&&i.addEventListener("click",()=>{o.classList.add("ecom-text--is-mark"),o.style.maxHeight="var(--ecom-text-height)",i.style.display="none",e.style.display=""}))

                    });
                    
                        document.querySelectorAll('.ecom-am4rnkwbol5').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-am4rnkwbol5', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-tfvhpyunjz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-tfvhpyunjz', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-z8rwnt3h5t').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-z8rwnt3h5t', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-m1i7wjcrjfs').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-m1i7wjcrjfs', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-1dgt91dvj0h').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-1dgt91dvj0h', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-8yn1y0dghet').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-8yn1y0dghet', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-t443dsutcer').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-t443dsutcer', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-n3cbqdawts').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-n3cbqdawts', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-e85u9h5gbas').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-e85u9h5gbas', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-fwz3acprs7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-fwz3acprs7i', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-irxlhszdlgf').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-irxlhszdlgf', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-mx6ptvng6f').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-mx6ptvng6f', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-vydre1qydtb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vydre1qydtb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-v1asn279fb').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-v1asn279fb', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-kkysnl2zl0k').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-kkysnl2zl0k', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-99czfyqbf37').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-99czfyqbf37', settings: {},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-npf621twuz').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-npf621twuz', settings: {},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-vnq7b4c945q"]=  window.__ectimmers["ecom-vnq7b4c945q"] || {};
if(!this.$el)return!1;const t=this.$el;this.settings.animation&&function(i){if(!t)return;const o=t.querySelector(".ecom__element--button");if(!o)return;let n=parseInt(i.settings.animation_loop_time)*1e3||6e3,s=1e3;window.__ectimmers["ecom-vnq7b4c945q"]["ikxj4lxso"] = setInterval(function(){o.classList.add("animated"),setTimeout(function(){o.classList.remove("animated")},s)},n)}(this);var e=t.querySelector(".ecom__element--button");this.isLive&&e&&e.dataset.ecTrackingId&&e.addEventListener("click",function(i){if(window.Shopify&&window.Shopify.analytics){i.preventDefault();let o=window.EComposer.PAGE||window.EComposer.TEMPLATE||window.EComposer.SECTION||window.EComposer.BLOCK||{};const n=Object.assign({button_id:e.id,tracking_id:e.dataset.ecTrackingId},o);try{Shopify.analytics.publish("ec_custom_events",n)}catch(a){console.error("[EC Tracking] Error publishing analytics event:",a)}const s=e.getAttribute("href"),r=e.getAttribute("target");s&&s!=="#"&&s!=="javascript:void(0)"&&(r==="_blank"?window.open(s,"_blank"):setTimeout(function(){window.location.href=s},300))}},{once:!0}),this.isLive&&e&&e.dataset.eventTrackingFb&&e.addEventListener("click",function(i){window.fbq&&window.fbq("track",`${e.dataset.eventTrackingFb}`)},{once:!0})

                    });
                    
                        document.querySelectorAll('.ecom-vnq7b4c945q').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-vnq7b4c945q', settings: {"animation":false},isLive: true});
                        });
                    

                })();
            
                (function(){
                    const Func = (function() {
                        'use strict';
window.__ectimmers = window.__ectimmers ||{};window.__ectimmers["ecom-dy1ed0aj906"]=  window.__ectimmers["ecom-dy1ed0aj906"] || {};
if(this.settings.link==="lightbox"&&this.settings.lightbox==="yes"&&window.EComModal&&this.$el){var t=this.$el.querySelector("[ecom-modal]");new window.EComModal(t,{cssClass:["ecom-container-lightbox-"+this.id]})}let e=this.$el;if(!e)return;function i(n){const s=n.getBoundingClientRect();return s.top>=0&&s.left>=0&&s.bottom-n.offsetHeight/2<=(window.innerHeight||document.documentElement.clientHeight)&&s.right<=(window.innerWidth||document.documentElement.clientWidth)}function o(){let n=e.querySelector(".ecom-element.ecom-base-image"),s=e.closest(".core__row--columns");n&&(i(n)?(n.classList.add("image-highlight"),s.setAttribute("style","z-index: unset")):(n.classList.remove("image-highlight"),s.setAttribute("style","z-index: 1")))}this.settings.highligh_on_viewport&&window.addEventListener("scroll",function(){o()})

                    });
                    
                        document.querySelectorAll('.ecom-dy1ed0aj906').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-dy1ed0aj906', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-znkaukme1r').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-znkaukme1r', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-0iu2vnfthlq').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-0iu2vnfthlq', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-16qyvi5ueje').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-16qyvi5ueje', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-rila1tsm9cm').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-rila1tsm9cm', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-04w59wmpd746').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-04w59wmpd746', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-7aa98q10w27').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-7aa98q10w27', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ddbjtqmwu89').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ddbjtqmwu89', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-heb69fc8cqa').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-heb69fc8cqa', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-j9h327yjbx').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-j9h327yjbx', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-eg7pqzsdl1').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-eg7pqzsdl1', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-w9nxop7gyn').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-w9nxop7gyn', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    
                        document.querySelectorAll('.ecom-ni0ywjef7i').forEach(function(el){
                            Func.call({$el: el, id: 'ecom-ni0ywjef7i', settings: {"link":"none","lightbox":"no","highligh_on_viewport":false},isLive: true});
                        });
                    

                })();
            
;try{
 
} catch(error){console.error(error);}